export default {
    POST_EVENT_KEY: 'anchor_post_unique_key',
    COLLECTION_EVENT_KEY: 'anchor_collection_unique_key',
    VIEW: 'view',
    CLICK: 'click',
    TILE_VIEW_EVENT: 'csf.tile.view',
    POST_TILE_VIEW_EVENT: 'csf.post.tile.view',
    COLLECTION_TILE_VIEW_EVENT: 'csf.collection.tile.view',
    POST_TILE_CLICK_EVENT: 'csf.post.tile.click',
    COLLECTION_TILE_CLICK_EVENT: 'csf.collection.tile.click',
    POST_TILE_HOVER_EVENT: 'csf.post.tile.hover',
    COLLECTION_TILE_HOVER_EVENT: 'csf.collection.tile.hover',
    POST_TILE_INTERACTION_EVENT: 'csf.post.tile.interaction',
    COLLECTION_TILE_INTERACTION_EVENT: 'csf.collection.tile.interaction',
    POST_TILE_CLICKED: 'postTileClicked',
    COLLECTION_TILE_CLICKED: 'collectionTileClicked',
    POST_TILE_HOVERED: 'postTileHovered',
    COLLECTION_TILE_HOVERED: 'collectionTileHovered',
    POST_DETAIL_VISIT: 'csf.post.tile.visit',
    PRODUCT_TILE_VIEW_EVENT: 'csf.product.tile.view',
    PRODUCT_TILE_CLICK_EVENT: 'csf.product.tile.click',
    COLLECTION: 'collection',
    POST: 'post',
    PRODUCT: 'product',
    FEATURED_PRODUCT_TILE_VIEW: 'storefrontfeaturedproductview',
    FEATURED_PRODUCT_TILE_CLICK: 'storefrontfeaturedproductclick'
};
